var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cube-loader"},[_c('div',{staticClass:"sh1"}),_c('div',{staticClass:"sh2"}),_c('div',{staticClass:"text-xs mt-6"},[_vm._v(_vm._s(_vm.$t('welcome.scan_code_processing'))+" ....")])])}
var staticRenderFns = []

export { render, staticRenderFns }